(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[486],{

/***/ 32985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ ImageButtonRow; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/button/Button.tsx + 1 modules
var Button = __webpack_require__(93636);
// EXTERNAL MODULE: ./content/imageButtonRow/ImageButtonRow.module.scss
var ImageButtonRow_module = __webpack_require__(28405);
var ImageButtonRow_module_default = /*#__PURE__*/__webpack_require__.n(ImageButtonRow_module);
;// CONCATENATED MODULE: ./content/imageButtonRow/ImageButton.tsx







var ImageButton = function(_param) {
    var label = _param.label, href = _param.href, paragraph = _param.paragraph, icon = _param.icon, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "href",
        "paragraph",
        "icon",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "a",
        href: href,
        target: "_blank",
        rel: "noreferrer",
        cardIcon: icon,
        className: (0,clsx_m/* default */.Z)(className, (ImageButtonRow_module_default())["image-button"])
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: label
                }),
                paragraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: paragraph
                })
            ]
        })
    }));
};


;// CONCATENATED MODULE: ./content/imageButtonRow/ImageButtonRow.tsx




var ImageButtonRow = function(param) {
    var title = param.title, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)((ImageButtonRow_module_default())["image-button-row"], className),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            })
        ]
    });
};
ImageButtonRow.Button = ImageButton;


/***/ }),

/***/ 19002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ MediaCarousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6277);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6917);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76453);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50589);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56050);
/* harmony import */ var _editable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85968);
/* harmony import */ var _sectionLabel__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12219);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68522);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73314);
/* harmony import */ var _MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7__);












var MediaCard = function(param) {
    var source = param.source, title = param.title, snippet = param.snippet, date = param.date, href = param.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_6__/* .Card */ .Z, {
            className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-card"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-source"]), typeof source === "string" && (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["source-text"])),
                    children: source
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-title"]),
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: snippet
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-date"]),
                    children: date
                })
            ]
        })
    });
};
var MediaCarousel = function() {
    var isMobile = (0,react_use__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("(max-width: 55rem)", true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_MediaCarousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["media-carousel"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sectionLabel__WEBPACK_IMPORTED_MODULE_10__/* .SectionLabel */ .e, {
                center: true,
                text: "Media"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                direction: "horizontal",
                slidesPerView: isMobile ? 1 : 3,
                spaceBetween: 25,
                loop: true,
                modules: isMobile ? [
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Autoplay */ .pt,
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl
                ] : [
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Autoplay */ .pt
                ],
                pagination: isMobile,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                speed: 1000,
                children: _editable__WEBPACK_IMPORTED_MODULE_3__/* .MEDIA_SLIDES.map */ .Qd.map(function(props, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaCard, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props))
                    }, i + props.title);
                })
            })
        ]
    });
};


/***/ }),

/***/ 57640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ NDAOTokenCallout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17982);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56963);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49423);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93636);
/* harmony import */ var _NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66404);
/* harmony import */ var _NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var NDAOTokenCallout = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["callout-container"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["callout-inner"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["ndao-callout"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .NDAOTokenIcon */ .k, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_3__/* .NVTTokenIcon */ .Y, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    children: "NDAO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: "Community Driven Impact"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                    as: "a",
                    className: (_NDAOTokenCallout_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["learn-more-button"]),
                    href: "/ndao",
                    children: [
                        "Learn More",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowIcon */ .e, {
                            width: 19.5,
                            height: 11.5
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 17982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ NDAOTokenIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);




var NDAOTokenIcon = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 86 : _width, height = _param.height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height !== null && height !== void 0 ? height : width,
        viewBox: "0 0 86 86",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "43",
                cy: "43",
                r: "41.5",
                fill: "#627EEA",
                stroke: "#1F49EA",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M26.5591 30.8527C29.2458 30.8527 31.4237 28.6747 31.4237 25.9879C31.4237 23.3018 29.2458 21.1238 26.5591 21.1238C23.8732 21.1238 21.6953 23.3018 21.6953 25.9879C21.6953 28.6747 23.8732 30.8527 26.5591 30.8527Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M26.5591 63.936C29.2458 63.936 31.4237 61.758 31.4237 59.0719C31.4237 56.385 29.2458 54.207 26.5591 54.207C23.8732 54.207 21.6953 56.385 21.6953 59.0719C21.6953 61.758 23.8732 63.936 26.5591 63.936Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M59.2796 30.8527C61.9656 30.8527 64.1434 28.6747 64.1434 25.9879C64.1434 23.3018 61.9656 21.1238 59.2796 21.1238C56.5929 21.1238 54.415 23.3018 54.415 25.9879C54.415 28.6747 56.5929 30.8527 59.2796 30.8527Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M59.2796 63.936C61.9656 63.936 64.1434 61.758 64.1434 59.0719C64.1434 56.385 61.9656 54.207 59.2796 54.207C56.5929 54.207 54.415 56.385 54.415 59.0719C54.415 61.758 56.5929 63.936 59.2796 63.936Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M36.0206 44.6904L29.2878 43.0071L15 46.837L16.8287 53.65L38.0351 47.9637L32.3095 69.1713L39.1087 71L42.9519 56.6719L41.256 49.9387C40.9478 48.6681 40.2972 47.5063 39.3736 46.5803C38.4506 45.6551 37.2905 45.0008 36.0206 44.6904Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M32.3095 16.8291L37.9955 38.0364L16.7891 32.35L15 39.1235L29.2878 42.9534L36.0206 41.3365C37.2972 41.0217 38.4618 40.3598 39.3855 39.4242C40.3092 38.4885 40.9568 37.3156 41.256 36.0352L42.9519 29.3013L39.1087 15L32.3095 16.8291Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M49.9264 41.3365L56.7129 42.9534L70.9999 39.1235L69.1847 32.3105L47.9783 37.9968L53.6643 16.7894L46.8383 15L42.9951 29.3282L44.6917 36.0352C44.9962 37.3126 45.6453 38.4826 46.5682 39.4175C47.4911 40.3524 48.6528 41.0164 49.9264 41.3365Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M49.9264 44.6904C48.664 45.003 47.5105 45.6529 46.5883 46.5699C45.6661 47.4877 45.0111 48.6382 44.6917 49.8992L42.9951 56.6324L46.8383 70.9605L53.6509 69.1713L47.9649 47.9637L69.1713 53.65L70.9873 46.837L56.7129 43.0071L49.9264 44.6904Z",
                fill: "white"
            })
        ]
    }));
};



/***/ }),

/***/ 56963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ NVTTokenIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);




var NVTTokenIcon = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 86 : _width, height = _param.height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height !== null && height !== void 0 ? height : width,
        viewBox: "0 0 86 86",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "43",
                cy: "43",
                r: "41.5",
                fill: "#EA6B0E",
                stroke: "#AA3401",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M36.6564 39.0465L33.0858 33.0954L20.2747 25.7007L16.7503 31.8112L35.7662 42.7855L16.7217 53.7328L20.2363 59.8337L33.0853 52.4198L36.6472 46.4595C37.3278 45.3432 37.6892 44.0616 37.6909 42.7538C37.6925 41.4469 37.3348 40.1639 36.6564 39.0465Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M53.7329 16.7218L42.7577 35.7382L31.7835 16.7222L25.7288 20.2467L33.1236 33.0578L39.0277 36.6752C40.153 37.3553 41.4445 37.7108 42.7593 37.7024C44.074 37.6939 45.3613 37.3224 46.4782 36.6286L52.439 33.0662L59.8339 20.2362L53.7329 16.7218Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M48.8605 46.5085L52.516 52.4506L65.3265 59.8449L68.8605 53.7438L49.8446 42.7695L68.861 31.7943L65.2995 25.7023L52.4506 33.1163L48.9077 39.0585C48.2197 40.177 47.8514 41.4633 47.8429 42.777C47.8344 44.0907 48.1863 45.3816 48.8605 46.5085Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M46.4892 48.8793C45.3755 48.2077 44.1003 47.8516 42.7998 47.848C41.4988 47.8448 40.222 48.1952 39.1046 48.861L33.1439 52.4224L25.7299 65.2713L31.8123 68.8234L42.7876 49.8069L53.7619 68.8228L59.8635 65.2894L52.4782 52.4878L46.4892 48.8793Z",
                fill: "white"
            })
        ]
    }));
};



/***/ }),

/***/ 95492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ StarCircleIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);




var StarCircleIcon = function(_param) /*#__PURE__*/ {
    var _width = _param.width, width = _width === void 0 ? 50 : _width, _height = _param.height, height = _height === void 0 ? 48 : _height, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _strokeColor = _param.strokeColor, strokeColor = _strokeColor === void 0 ? "currentColor" : _strokeColor, _strokeWidth = _param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 1.5 : _strokeWidth, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "color",
        "strokeColor",
        "strokeWidth"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height,
        viewBox: "0 0 50 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("mask", {
                maskUnits: "userSpaceOnUse",
                x: "18.538",
                y: "0",
                width: "31",
                height: "31",
                fill: "black",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        fill: "white",
                        x: "18.538",
                        width: "31",
                        height: "31"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M34.2145 2L35.9242 10.8028C36.2352 12.4039 37.4871 13.6559 39.0882 13.9668L47.8911 15.6765L39.0882 17.3863C37.4871 17.6972 36.2352 18.9492 35.9242 20.5502L34.2145 29.3531L32.5048 20.5502C32.1938 18.9492 30.9419 17.6972 29.3408 17.3863L20.538 15.6765L29.3408 13.9668C30.9419 13.6559 32.1938 12.4039 32.5048 10.8029L34.2145 2Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M34.2145 2L35.9242 10.8028C36.2352 12.4039 37.4871 13.6559 39.0882 13.9668L47.8911 15.6765L39.0882 17.3863C37.4871 17.6972 36.2352 18.9492 35.9242 20.5502L34.2145 29.3531L32.5048 20.5502C32.1938 18.9492 30.9419 17.6972 29.3408 17.3863L20.538 15.6765L29.3408 13.9668C30.9419 13.6559 32.1938 12.4039 32.5048 10.8029L34.2145 2Z",
                fill: color,
                fillOpacity: "0.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M34.2145 2L35.687 1.71401C35.5501 1.00903 34.9327 0.5 34.2145 0.5C33.4964 0.5 32.8789 1.00903 32.742 1.71401L34.2145 2ZM47.8911 15.6765L48.177 17.149C48.882 17.0121 49.3911 16.3947 49.3911 15.6765C49.3911 14.9584 48.882 14.341 48.177 14.2041L47.8911 15.6765ZM34.2145 29.3531L32.742 29.6391C32.8789 30.3441 33.4964 30.8531 34.2145 30.8531C34.9327 30.8531 35.5501 30.3441 35.687 29.6391L34.2145 29.3531ZM20.538 15.6765L20.252 14.2041C19.547 14.341 19.038 14.9584 19.038 15.6765C19.038 16.3947 19.547 17.0121 20.252 17.149L20.538 15.6765ZM32.5048 10.8029L31.0323 10.5169L32.5048 10.8029ZM29.3408 17.3863L29.0548 18.8587L29.3408 17.3863ZM39.0882 17.3863L38.8022 15.9138L39.0882 17.3863ZM39.0882 13.9668L38.8022 15.4393L39.0882 13.9668ZM32.742 2.28599L34.4517 11.0888L37.3967 10.5169L35.687 1.71401L32.742 2.28599ZM38.8022 15.4393L47.6051 17.149L48.177 14.2041L39.3742 12.4944L38.8022 15.4393ZM47.6051 14.2041L38.8022 15.9138L39.3742 18.8587L48.177 17.149L47.6051 14.2041ZM34.4517 20.2643L32.742 29.0671L35.687 29.6391L37.3967 20.8362L34.4517 20.2643ZM35.687 29.0671L33.9773 20.2643L31.0323 20.8362L32.742 29.6391L35.687 29.0671ZM29.6268 15.9138L20.824 14.2041L20.252 17.149L29.0548 18.8587L29.6268 15.9138ZM20.824 17.149L29.6268 15.4393L29.0548 12.4944L20.252 14.2041L20.824 17.149ZM33.9773 11.0888L35.687 2.28599L32.742 1.71401L31.0323 10.5169L33.9773 11.0888ZM29.6268 15.4393C31.8283 15.0117 33.5497 13.2903 33.9773 11.0888L31.0323 10.5169C30.838 11.5175 30.0555 12.3 29.0548 12.4944L29.6268 15.4393ZM33.9773 20.2643C33.5497 18.0628 31.8283 16.3413 29.6268 15.9138L29.0548 18.8587C30.0555 19.0531 30.838 19.8355 31.0323 20.8362L33.9773 20.2643ZM38.8022 15.9138C36.6007 16.3413 34.8793 18.0628 34.4517 20.2643L37.3967 20.8362C37.5911 19.8355 38.3735 19.0531 39.3742 18.8587L38.8022 15.9138ZM34.4517 11.0888C34.8793 13.2903 36.6007 15.0117 38.8022 15.4393L39.3742 12.4944C38.3735 12.3 37.5911 11.5175 37.3967 10.5169L34.4517 11.0888Z",
                fill: color,
                mask: "url(#path-1-outside-1_2310_4897)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.769 27.3993L11.8432 32.93C12.1541 34.5311 13.4061 35.7831 15.0071 36.094L20.5379 37.1682L15.0071 38.2424C13.4061 38.5534 12.1541 39.8053 11.8432 41.4064L10.769 46.9372L9.69477 41.4064C9.3838 39.8053 8.13187 38.5534 6.53078 38.2424L1 37.1682L6.53078 36.094C8.13187 35.7831 9.3838 34.5311 9.69477 32.93L10.769 27.3993Z",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.769 27.3993L11.5052 27.2563C11.4367 26.9038 11.128 26.6493 10.769 26.6493C10.4099 26.6493 10.1012 26.9038 10.0327 27.2563L10.769 27.3993ZM20.5379 37.1682L20.6809 37.9045C21.0334 37.836 21.2879 37.5273 21.2879 37.1682C21.2879 36.8091 21.0334 36.5004 20.6809 36.432L20.5379 37.1682ZM10.769 46.9372L10.0327 47.0802C10.1012 47.4327 10.4099 47.6872 10.769 47.6872C11.128 47.6872 11.4367 47.4327 11.5052 47.0802L10.769 46.9372ZM1 37.1682L0.857006 36.432C0.504513 36.5004 0.25 36.8091 0.25 37.1682C0.25 37.5273 0.504513 37.836 0.857006 37.9045L1 37.1682ZM15.0071 38.2424L14.8642 37.5062L15.0071 38.2424ZM11.8432 41.4064L11.1069 41.2634L11.8432 41.4064ZM11.8432 32.93L11.1069 33.073L11.8432 32.93ZM15.0071 36.094L14.8642 36.8303L15.0071 36.094ZM10.0327 27.5423L11.1069 33.073L12.5794 32.787L11.5052 27.2563L10.0327 27.5423ZM14.8642 36.8303L20.3949 37.9045L20.6809 36.432L15.1501 35.3578L14.8642 36.8303ZM20.3949 36.432L14.8642 37.5062L15.1501 38.9787L20.6809 37.9045L20.3949 36.432ZM11.1069 41.2634L10.0327 46.7942L11.5052 47.0802L12.5794 41.5494L11.1069 41.2634ZM11.5052 46.7942L10.431 41.2634L8.95852 41.5494L10.0327 47.0802L11.5052 46.7942ZM6.67377 37.5062L1.14299 36.432L0.857006 37.9045L6.38778 38.9787L6.67377 37.5062ZM1.14299 37.9045L6.67377 36.8303L6.38778 35.3578L0.857006 36.432L1.14299 37.9045ZM10.431 33.073L11.5052 27.5423L10.0327 27.2563L8.95852 32.787L10.431 33.073ZM6.67377 36.8303C8.57507 36.461 10.0617 34.9743 10.431 33.073L8.95852 32.787C8.70586 34.0879 7.68867 35.1051 6.38778 35.3578L6.67377 36.8303ZM10.431 41.2634C10.0617 39.3621 8.57507 37.8755 6.67377 37.5062L6.38778 38.9787C7.68867 39.2313 8.70586 40.2485 8.95852 41.5494L10.431 41.2634ZM14.8642 37.5062C12.9629 37.8755 11.4762 39.3621 11.1069 41.2634L12.5794 41.5494C12.8321 40.2485 13.8493 39.2313 15.1501 38.9787L14.8642 37.5062ZM11.1069 33.073C11.4762 34.9743 12.9629 36.461 14.8642 36.8303L15.1501 35.3578C13.8493 35.1051 12.8321 34.0879 12.5794 32.787L11.1069 33.073Z",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M41.5497 22.2277C42.3172 25.5361 42.1623 28.9918 41.1018 32.2183C40.0412 35.4449 38.1157 38.3185 35.5349 40.5264C32.9541 42.7343 29.817 44.1917 26.4652 44.74C23.1134 45.2883 19.6754 44.9064 16.5256 43.6359",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.33557 30.3841C4.66918 27.334 4.78295 24.1651 5.66634 21.1706C6.54972 18.1761 8.17419 15.4528 10.3894 13.2528C12.6046 11.0527 15.339 9.44702 18.3395 8.58422C21.34 7.72143 24.5096 7.62944 27.5551 8.31677",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};



/***/ }),

/***/ 9357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ StarIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var StarIcon = function(param) {
    var _startColor = param.startColor, startColor = _startColor === void 0 ? "currentColor" : _startColor, _endColor = param.endColor, endColor = _endColor === void 0 ? "currentColor" : _endColor;
    var gradientId = "gradient-".concat(startColor.replace(/[^\dA-Za-z]/g, ""), "-").concat(endColor.replace(/[^\dA-Za-z]/g, ""));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                id: gradientId,
                x1: "0%",
                y1: "100%",
                x2: "100%",
                y2: "100%",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: "0%",
                        style: {
                            stopColor: startColor,
                            stopOpacity: 1
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                        offset: "100%",
                        style: {
                            stopColor: endColor,
                            stopOpacity: 1
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16 0L17.3773 5.65779C18.4962 10.2545 22.1317 13.8149 26.7508 14.8377L32 16L26.4191 17.398C21.9781 18.5105 18.5105 21.9781 17.398 26.4191L16 32L14.602 26.4191C13.4895 21.9781 10.0219 18.5105 5.58089 17.398L0 16L5.58089 14.602C10.0219 13.4895 13.4895 10.0219 14.602 5.58089L16 0Z",
                fill: "url(#".concat(gradientId, ")")
            })
        ]
    });
};


/***/ }),

/***/ 95368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SupportIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);


var SupportIcon = function(_param) /*#__PURE__*/ {
    var _width = _param.width, width = _width === void 0 ? 48 : _width, _height = _param.height, height = _height === void 0 ? 45 : _height, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _strokeColor = _param.strokeColor, strokeColor = _strokeColor === void 0 ? "currentColor" : _strokeColor, _strokeWidth = _param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 1.5 : _strokeWidth, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "color",
        "strokeColor",
        "strokeWidth"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3 25C4.66667 27.6667 5.2751 30.5813 8.5 33C11.8333 35.5 17 35.5 18.5 35.5",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "24",
                cy: "25",
                r: "19.25",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M45 19C45 10.8545 37.5 1 24 1C10.5 1 3 10.8545 3 19",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M33.9112 29.5551C32.7734 33.6419 28.8383 36.25 24 36.25C19.1617 36.25 15.2266 33.6419 14.0888 29.5551C13.9938 29.214 14.1073 28.9334 14.3568 28.7317C14.6239 28.5158 15.0422 28.4061 15.4726 28.5237C17.7813 29.1546 21.2287 29.95 24 29.95C26.7713 29.95 30.2187 29.1546 32.5274 28.5237C32.9578 28.4061 33.3761 28.5158 33.6432 28.7317C33.8927 28.9334 34.0062 29.214 33.9112 29.5551Z",
                fill: color,
                fillOpacity: "0.25",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M21 23C21 20.7909 19.433 19 17.5 19C15.567 19 14 20.7909 14 23",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M34 23C34 20.7909 32.433 19 30.5 19C28.567 19 27 20.7909 27 23",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.75",
                y: "18.75",
                width: "3.5",
                height: "10.5",
                rx: "1.25",
                fill: color,
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "43.75",
                y: "18.75",
                width: "3.5",
                height: "10.5",
                rx: "1.25",
                fill: color,
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "12.582",
                y: "31.8936",
                width: "12.6235",
                height: "6",
                rx: "3",
                transform: "rotate(2.32554 12.582 31.8936)",
                fill: color
            })
        ]
    });
};



/***/ }),

/***/ 28405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image-button-row":"ImageButtonRow_image-button-row__pLIpz","image-button":"ImageButtonRow_image-button__PmKJN","slide":"ImageButtonRow_slide__LkM6v","dash":"ImageButtonRow_dash__gfjCU","spin":"ImageButtonRow_spin__P9O4Y","rotate":"ImageButtonRow_rotate__lqfkg","floating":"ImageButtonRow_floating__Sljyb"};

/***/ }),

/***/ 73314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"media-carousel":"MediaCarousel_media-carousel__KqPYx","media-card":"MediaCarousel_media-card__HA87Y","spin":"MediaCarousel_spin__stzby","media-source":"MediaCarousel_media-source__2hdPY","source-text":"MediaCarousel_source-text___aRQ9","media-title":"MediaCarousel_media-title__YJ6Rd","media-date":"MediaCarousel_media-date__0iIDS","slide":"MediaCarousel_slide__qcXF2","dash":"MediaCarousel_dash__2lSjm","rotate":"MediaCarousel_rotate__TtR36","floating":"MediaCarousel_floating__nkc8T"};

/***/ }),

/***/ 66404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"callout-container":"NDAOTokenCallout_callout-container__tFF_s","callout-inner":"NDAOTokenCallout_callout-inner__qrVhf","ndao-callout":"NDAOTokenCallout_ndao-callout__WFHjQ","rotate":"NDAOTokenCallout_rotate__Z6Ylo","learn-more-button":"NDAOTokenCallout_learn-more-button__myuul","slide":"NDAOTokenCallout_slide__CnuN5","dash":"NDAOTokenCallout_dash__TqIFA","spin":"NDAOTokenCallout_spin__9OTFO","floating":"NDAOTokenCallout_floating___agGm"};

/***/ })

}]);